import React, { useState } from 'react';
import Timetables from './Timetables';
import './TrainSchedule.css';

const TrainSchedulePage = () => {
  const [activeTab, setActiveTab] = useState('timetables');

  return (
    <div className="train-schedule-page">
      {/* Tab Navigation */}
      <div className="tab-navigation">
        <button
          className={`tab-button ${activeTab === 'timetables' ? 'active' : ''}`}
          onClick={() => setActiveTab('timetables')}
        >
          Timetables
        </button>
        <button
          className={`tab-button ${activeTab === 'services' ? 'active' : ''}`}
          onClick={() => setActiveTab('services')}
        >
          Services
        </button>
      </div>

      {/* Timetables Tab */}
      {activeTab === 'timetables' && (
        <Timetables />
      )}

      {/* Services Tab */}
      {activeTab === 'services' && (
        <ServicesTab />
      )}
    </div>
  );
};

// Services Tab Component
const ServicesTab = () => {
  return (
    <div className="services-container">
      <div className="services-content">
        <h1>AG&WESTERN Rail Services</h1>
        <p>Services content coming soon...</p>
      </div>
    </div>
  );
};

export default TrainSchedulePage;
